module.exports = __webpack_public_path__ + "static/media/photo1.a928e4ee.png";